import { render, staticRenderFns } from "./ActiveAlertBanner.vue?vue&type=template&id=20c294f8&"
import script from "./ActiveAlertBanner.vue?vue&type=script&lang=js&"
export * from "./ActiveAlertBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports